import axios from 'axios';
import { API_URL } from '../ApiConfig';



export const Login = async (Dados) => {
  try {
    const response = await axios.post(`${API_URL}/login`, Dados);
    return response.data;
  } catch (error) {
    const response = error.response;

    // Retorna tudo o que o backend mandou (inclusive token)
    return {
      success: response?.data?.success || false,
      message: response?.data?.message || 'Erro inesperado.',
      token: response?.data?.token || null
    };
  }
};

